document.addEventListener("alpine:init", () => {
    Alpine.data("gridFilter", () => ({
        currentFilters: {},
        showResetBtn: false,
        dropdownOpen: false,
        filterPrefix: {
            taxonomy: "filter-t-",
            meta: "filter-m-",
            search: "",
        },
        secondaryDropdownOpen: false,
        init() {
            this.currentFilters = this.getCurrentFilters();

            if (Object.keys(this.currentFilters).length) {
                this.showResetBtn = true;
            }
        },
        selectFilter(term, filterName, type = "taxonomy") {
            this.toggleFilters(term, filterName, type);

            this.$dispatch("pegasus-grid-filter-toggle", {
                currentFilters: this.currentFilters,
            });

            this.showResetBtn = true;
        },
        /**
         * toggleFilters
         *
         * Description: Either add or remove the filter term from
         * it's taxonomy.
         *
         * @param {string} term
         * @param {string} filterName
         * @param {string} type
         * @return void
         */
        toggleFilters(term = "", filterName = "", type = "taxonomy") {
            const filter = this.getPrefixedFilter(filterName, type);

            // If this is the first filter to be added, just add it.
            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = term;

                return;
            }

            // If we have filters for the current filter, check if the term is already in the list.
            if (this.currentFilters[filter].length) {
                if (this.currentFilters[filter].includes(term)) {
                    // If the term is already in the list, remove it from the filter.
                    this.currentFilters[filter] = this.removeFilter(
                        filter,
                        term
                    );
                    // If this filter filter is now empty, remove it from the current filters.
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    // If the term is not already in the list, add it.
                    this.currentFilters[filter] += "," + term;
                }
            } else {
                // If there isn't a filter for this filter, add it and then add the term to it.
                this.currentFilters[filter] = term;
            }
        },

        /**
         * removeFilter
         *
         * Description: Removes a given term from it's taxonomy filter.
         *
         * @param {string} filter
         * @param {string} value
         * @return string
         */
        removeFilter(filter, value) {
            // Get the filter values from the currentFilters array
            const filterValue = this.currentFilters[filter];

            // Turn the filter values into an array
            const filterValueArray = filterValue.split(",");

            // Loop through the array and remove the given value
            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }

            // Return the array as a string
            return filterValueArray.toString();
        },

        /**
         * clearFilters
         *
         * Description: Empty the current filters and refresh the page.
         *
         * @return void
         */
        clearFilters() {
            this.currentFilters = {};
            this.$dispatch("pegasus-grid-filter-toggle", {
                currentFilters: this.currentFilters,
            });
            this.showResetBtn = false;
        },
        /**
         * getPrefixedFilter
         * @param {string} filter
         * @param {string} type
         * @return {string}
         */
        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        },
        /**
         * getCurrentFilters
         *
         * Description: Get the current filters from the url.
         *
         * @return object
         */
        getCurrentFilters() {
            // Get the current url and parse the query string.
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            let currentFilters = {};

            // Loop through the query string and add each filter to the currentFilters object.
            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }

            return currentFilters;
        },

        /**
         * filterIsActive
         *
         * Description: Checks if a given filter is currently selected.
         *
         * @param {string} filter
         * @param {string} term
         * @param {string} type
         * @return {boolean}
         */
        filterIsActive(term, filter, type = "taxonomy") {
            const filterName = this.getPrefixedFilter(filter, type);
            if (typeof this.currentFilters[filterName] !== "undefined") {
                return this.currentFilters[filterName].includes(term);
            }
            return false;
        },
    }));
});
